import '.ao{position:relative;}.ssr-plugin'
import '.l0{width:64px;}.ssr-plugin'
import '.l1{height:64px;}.ssr-plugin'
import '.at{flex-shrink:0;}.ssr-plugin'
import '.bj{position:absolute;}.ssr-plugin'
import '.l2{bottom:-4px;}.ssr-plugin'
import '.j6{right:-4px;}.ssr-plugin'
import '.h0{border-radius:50%;}.ssr-plugin'
import '.ck{border:2px solid var(--palette-white);}.ssr-plugin'
import '.b7{overflow:hidden;}.ssr-plugin'
import '.l3{width:32px;}.ssr-plugin'
import '.l4{height:32px;}.ssr-plugin'
import { styled } from 'inlines'
import { Avatar } from '@app/components/core/avatar/Avatar'
import { Image } from '@app/components/core/image/Image'
import { StoredImage } from '@app/types/StoredImage'

type ConversationAvatarProps = {
  initiativeImage?: StoredImage
  userAvatar?: string
  userName: string
}

export const ConversationAvatar = ({
  initiativeImage,
  userAvatar,
  userName,
}: ConversationAvatarProps) => {
  const hasImage = !!initiativeImage && !!initiativeImage.src
  return (
    <div className="ao l0 l1 at"
    >
      {hasImage ? (
        <Image
          src={initiativeImage.src}
          alt={initiativeImage.altText || 'initiative image'}
          resizeWidth={128}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: '12px',
          }}
        />
      ) : (
        <Avatar
          size="medium"
          shape="square"
          labelSource={userName}
          variant="yellow"
        />
      )}
      <div className="bj l2 j6 h0 ck b7 l3 l4"
      >
        <Avatar
          size="extra-small"
          shape="circle"
          image={userAvatar}
          labelSource={userName}
        />
      </div>
    </div>
  )
}
